import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationComponent } from './notification.component';
import { DefaultImageModule } from 'src/app/common/default-image/default-image.module';



@NgModule({
  declarations: [
    NotificationComponent
  ],
  imports: [
    CommonModule,
    DefaultImageModule
  ],
  exports: [
    NotificationComponent
  ]
})
export class NotificationModule { }
